/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1780444800000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Wed Jun 03 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "google-data-manager",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Google Data Manager",
          "depth": 0,
          "id": "connect-to-google-data-manager"
        }, {
          "value": "Sync data to Google Ads",
          "depth": 1,
          "id": "sync-data-to-google-ads"
        }, {
          "value": "Existing Partner Link",
          "depth": 1,
          "id": "existing-partner-link"
        }, {
          "value": "Enter your account ID",
          "depth": 1,
          "id": "enter-your-account-id"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing Google Ads audience members",
          "depth": 1,
          "id": "syncing-google-ads-audience-members"
        }, {
          "value": "Syncing Display & Video 360 audiences",
          "depth": 1,
          "id": "syncing-display--video-360-audiences"
        }, {
          "value": "Syncing Google Ads events",
          "depth": 1,
          "id": "syncing-google-ads-events"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      a: "a",
      strong: "strong",
      p: "p",
      h3: "h3",
      code: "code",
      h4: "h4",
      ul: "ul",
      li: "li",
      em: "em",
      ol: "ol"
    }, _provideComponents(), props.components), {MatchBoosterDestination, EventSyncWarning, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!MatchBoosterDestination) _missingMdxReference("MatchBoosterDestination", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported sync modes"
            }), _jsx(_components.th, {
              children: "API reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-google-ads-audience-members",
                children: _jsx(_components.strong, {
                  children: "Google Ads Audiences"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync records as audience members in Google Data Manager via the Data Manager API"
            }), _jsx(_components.td, {
              children: "Add"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/data-manager/api/get-started/quickstart/send-audience-members",
                children: "Audience Members"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-display--video-360-audiences",
                children: _jsx(_components.strong, {
                  children: "Display & Video 360 Audiences"
                })
              })
            }), _jsx(_components.td, {
              children: "Create and update first and third party audiences in Google Display & Video 360"
            }), _jsx(_components.td, {
              children: "Add"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/display-video/api/guides/audiences/overview",
                children: "Display & Video 360 Audiences"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-google-ads-events",
                children: _jsx(_components.strong, {
                  children: "Google Ads Conversion Events"
                })
              })
            }), _jsx(_components.td, {
              children: "Send Online and Offline events to Google Data Manager via the Data Manager API"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.google.com/data-manager/api/get-started/quickstart/send-events",
                children: "Events"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-google-data-manager",
        children: "Connect to Google Data Manager"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button.\nSelect ", _jsx(_components.strong, {
          children: "Google Data Manager"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". Select whether you'd like to send data to Google Ads or Display & Video 360."]
      }), "\n", _jsx(_components.p, {
        children: "For Google Ads, Hightouch supports two authentication methods:"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Method"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Sync data to Google Ads"
              })
            }), _jsx(_components.td, {
              children: "OAuth-based authentication. Hightouch creates a partner link between Hightouch and your Google Ads account during the first sync run. Recommended for most destinations."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Existing Partner Link"
              })
            }), _jsx(_components.td, {
              children: "A method for accounts that already have a Hightouch partner link. Use this when the OAuth method can't create the partner link for you."
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "sync-data-to-google-ads",
        children: "Sync data to Google Ads"
      }), "\n", _jsxs(_components.p, {
        children: ["Select ", _jsx(_components.strong, {
          children: "Sync data to Google Ads"
        }), ", click ", _jsx(_components.strong, {
          children: "Log in to Google Data Manager"
        }), ", log in with your Google Account, and click ", _jsx(_components.strong, {
          children: "Allow"
        }), ".\nYou should then see a success notification in the Hightouch UI."]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch creates the partner link during the first sync run. Creating the partner link requires the authenticating user to have ", _jsx(_components.strong, {
          children: "Admin"
        }), " access on the Google Ads account. If the user doesn't have Admin access, the sync fails with a ", _jsx(_components.code, {
          children: "PERMISSION_DENIED"
        }), " error. See ", _jsx(_components.a, {
          href: "#permission_denied-from-data-manager-api",
          children: "PERMISSION_DENIED from Data Manager API"
        }), " to verify and fix the access level."]
      }), "\n", _jsx(_components.h3, {
        id: "existing-partner-link",
        children: "Existing Partner Link"
      }), "\n", _jsx(_components.p, {
        children: "Use this method if the OAuth method can't create the partner link for you and you already have a Hightouch partner link set up in your Google Ads account."
      }), "\n", _jsxs(_components.p, {
        children: ["Unlike the OAuth method, this method doesn't create the partner link for you. Before connecting, create the partner link in your Google Ads account by linking ", _jsx(_components.strong, {
          children: "Hightouch"
        }), " as a data provider. See Google's ", _jsx(_components.a, {
          href: "https://developers.google.com/data-manager/api/devguides/concepts/destinations#ads-credentials",
          children: "data partner linking"
        }), " documentation for details."]
      }), "\n", _jsx(_components.h3, {
        id: "enter-your-account-id",
        children: "Enter your account ID"
      }), "\n", _jsx(_components.p, {
        children: "Enter the Google Ads or Display & Video 360 account ID you'd like to use with this destination. You can find this value in Google, at the top-right corner with your account information. This should be a 10 digit value. Remove any dashes that may be present in your account ID."
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Google Data Manager destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data.\nGo to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin.\nThen, select the relevant model and the Google Data Manager destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-google-ads-audience-members",
        children: "Syncing Google Ads audience members"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch lets you create and maintain customer match lists via the Google Data Manager API.\nIt can take 6 to 48 hours for a list to be populated with members once Hightouch has sent the data to Google."
      }), "\n", _jsx(_components.h4, {
        id: "user-list-type",
        children: "User list type"
      }), "\n", _jsx(_components.p, {
        children: "To begin, select which type of Customer Match User List you'd like to create or sync to. The available options are:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "CONTACT_INFO"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "MOBILE_ADVERTISING_ID"
          })
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "select-an-existing-list-or-create-a-new-one",
        children: "Select an existing list or create a new one"
      }), "\n", _jsxs(_components.p, {
        children: ["You can create a new ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/6276125",
          children: "Customer match user list"
        }), " or use an existing one.\nWhen creating a new list, you can optionally enter a name.\nOtherwise, Hightouch defaults to the name of the associated model."]
      }), "\n", _jsxs(_components.p, {
        children: ["To use an existing list, enter the list's ID in the following format: ", _jsx(_components.code, {
          children: "products/{product}/customers/{customer_id}/userLists/{user_list_id}"
        }), ". Example: ", _jsx(_components.code, {
          children: "products/GOOGLE_ADS/customers/12345678/userLists/12345678"
        })]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["If you choose to create a new list, you can't update the\n", _jsx(_components.a, {
            href: "#select-account",
            children: "account"
          }), " to which you're syncing data after the initial sync\nrun. If you need to change the account, configure a new sync."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers",
        children: "User identifiers"
      }), "\n", _jsx(_components.p, {
        children: "Select which columns in your model you'd like to send to Google Ads as user identifiers."
      }), "\n", _jsxs(_components.p, {
        children: ["For user lists with the Contact Info type, you must select ", _jsx(_components.em, {
          children: "either"
        }), " hashed email addresses or hashed phone numbers. If you choose to sync addresses, all fields of the address are required."]
      }), "\n", _jsx(_components.p, {
        children: "For user lists with the Mobile Advertising ID type, the mobile advertising ID is required."
      }), "\n", _jsx(MatchBoosterDestination, {
        destinationName: "Google Data Manager audience members"
      }), "\n", _jsx(_components.h4, {
        id: "handling-pii-and-hashing",
        children: "Handling PII and hashing"
      }), "\n", _jsxs(_components.p, {
        children: ["You can enable PII hashing if you wish for Hightouch to detect whether your data requires normalization and hashing based on the chosen record mapping.\nFor example, if you select ", _jsx(_components.strong, {
          children: "Email"
        }), " and the model column with the email data is unhashed, Hightouch hashes the value for you."]
      }), "\n", _jsx(_components.p, {
        children: "By default, Hightouch automatically detects if the following fields require hashing:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Email"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Phone"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Given name"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Family name"
          })
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["If you are uploading data for users in the European Economic Area (", _jsx(_components.a, {
          href: "https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:European_Economic_Area_(EEA)",
          children: "EEA"
        }), "),\nyou need to ensure you are passing the required consent signals to ", _jsx(_components.a, {
          href: "https://www.google.com/about/company/user-consent-policy/?sjid=2196795394224792925-NA",
          children: "Google"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "For each sync, you can specify the consent status for these types:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "ad_user_data"
          }), ": consent for sending user data to Google for advertising purposes"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "ad_personalization"
          }), ": consent for ad personalization"]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Check out Google's support ", _jsx(_components.a, {
          href: "https://support.google.com/google-ads/answer/14310715?hl=en",
          children: "doc"
        }), " to learn more."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-display--video-360-audiences",
        children: "Syncing Display & Video 360 audiences"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch allows you to create and update first and third party audiences in Google Display & Video 360 as customer match user lists. These lists support adding members using mobile device ID or an array of email, phone numbers, and physical addresses."
      }), "\n", _jsx(_components.p, {
        children: "When creating the audience, make sure the source of the data is properly selected between first or third party sources."
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers-1",
        children: "User identifiers"
      }), "\n", _jsx(_components.p, {
        children: "Mobile device IDs and other user identifiers cannot be mixed. Also, if providing the user's physical address, the zip code, country code, first and last name must be provided."
      }), "\n", _jsxs(_components.p, {
        children: ["Phone numbers must be in ", _jsx(_components.a, {
          href: "https://en.wikipedia.org/wiki/E.164",
          children: "E.164"
        }), " format."]
      }), "\n", _jsx(MatchBoosterDestination, {
        destinationName: "Google Data Manager Display & Video 360 audiences"
      }), "\n", _jsx(_components.h4, {
        id: "user-consent",
        children: "User consent"
      }), "\n", _jsxs(_components.p, {
        children: ["Starting in March 2024, Display & Video 360 introduced the ", _jsx(_components.a, {
          href: "https://developers.google.com/display-video/api/guides/audiences/upload-customer-match?sjid=10202302840984618943-NA#set_user_consent",
          children: "consent object"
        }), " for uploading consent with customer match data. The consent object specifies two distinct types of consent and users must grant both types of consent to use their data for customer match lists. Reference the ", _jsx(_components.a, {
          href: "https://support.google.com/displayvideo/answer/14673239?hl=en",
          children: "DV360 docs"
        }), " for more information."]
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "If you don't set the consent status or if the status is denied, the sync\nresults in an error."
        })
      }), "\n", _jsx(_components.h4, {
        id: "pii-data-and-hashing",
        children: "PII data and hashing"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch automatically hashes all the PII data before it's sent to Google. If the data is already hashed, this option can be disabled. Reference the ", _jsx(_components.a, {
          href: "https://developers.google.com/display-video/api/reference/rest/v1/firstAndThirdPartyAudiences#ContactInfo",
          children: "DV360 docs"
        }), " for more information."]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Google's Personalized Ads Policy, Customer Match Policy and Platforms program\npolicies include requirements for advertisers to show sufficiently established\nGoogle Ads or Display & Video 360 account history before accessing certain\nfeatures. To enable uploading data to DV360, please fill ", _jsx(_components.a, {
            href: "https://support.google.com/displayvideo/answer/9176010",
            children: "this\nform"
          }), " before you\ncreate the sync."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "syncing-google-ads-events",
        children: "Syncing Google Ads events"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports syncing:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Online events: Send event data as an additional data source for your tag conversions, to maximize ad interaction signals and strengthen your data and overall performance."
        }), "\n", _jsxs(_components.li, {
          children: ["Offline events: Send event data for ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/2998031",
            children: "offline conversions"
          }), " or ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/15713840",
            children: "enhanced conversions for leads"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing conversion events, Hightouch treats any records added to ", _jsx(_components.a, {
          href: "/getting-started/concepts",
          children: "your source"
        }), " as new events and sends them to Google Data Manager when your sync runs."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Select which columns in your model you'd like to sync as attributes of conversion events."
      }), "\n", _jsx(_components.p, {
        children: "Google Data Manager requires the following fields for each event:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Event timestamp (event_timestamp): The time the event occurred."
        }), "\n", _jsx(_components.li, {
          children: "Transaction ID (transaction_id): The unique identifier for the event."
        }), "\n", _jsx(_components.li, {
          children: "Event source (event_source): The source of the event. Required for offline events. Optional for online events. If specified for an online event, must be WEB."
        }), "\n", _jsx(_components.li, {
          children: "Ad identifiers (GCLID, GBRAID, or WBRAID) or user data (email, phone, or address): The event must have either an ad identifier or user data. Send both if you have both for the event."
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["The accepted values for ", _jsx(_components.code, {
          children: "event_source"
        }), " are:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "EVENT_SOURCE_UNSPECIFIED"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "WEB"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "APP"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "IN_STORE"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "PHONE"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "OTHER"
          })
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Additional user properties mappings include:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Customer type", "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["Accepted values: ", _jsx(_components.code, {
                children: "CUSTOMER_TYPE_UNSPECIFIED"
              }), ", ", _jsx(_components.code, {
                children: "NEW"
              }), ", ", _jsx(_components.code, {
                children: "RETURNING"
              }), ", ", _jsx(_components.code, {
                children: "REENGAGED"
              })]
            }), "\n"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["Customer value bucket", "\n", _jsxs(_components.ul, {
            children: ["\n", _jsxs(_components.li, {
              children: ["Accepted values: ", _jsx(_components.code, {
                children: "CUSTOMER_VALUE_BUCKET_UNSPECIFIED"
              }), ", ", _jsx(_components.code, {
                children: "LOW"
              }), ", ", _jsx(_components.code, {
                children: "MEDIUM"
              }), ", ", _jsx(_components.code, {
                children: "HIGH"
              })]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "landing-page-device-info-recommended-for-online-events",
        children: "Landing page device info (recommended for online events)"
      }), "\n", _jsx(_components.p, {
        children: "For online events, we recommend collecting and sending information about the device being used (if any) when the event happened. This will improve the likelihood that conversion events can be accurately attributed back to ad interactions, resulting in more accurate reporting and better performance as Google's AI systems learn and improve from each attributed conversion."
      }), "\n", _jsxs(_components.p, {
        children: ["To map device information to your conversion events, select ", _jsx(_components.code, {
          children: "Landing page device info"
        }), " and map the following fields:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "userAgent"
          }), " - user-agent string of the device for the given context."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "ipAddress"
          }), " - The IP address of the device for the given context."]
        }), "\n"]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Google Ads does ", _jsx(_components.strong, {
            children: "not"
          }), " support IP address matching for end users in the\nEuropean Economic Area (EEA), United Kingdom (UK), or Switzerland (CH). We\nrecommend adding logic directly in your model to conditionally exclude sharing\nIP addresses from users from these regions and ensure that you provide users\nwith clear and comprehensive information about the data you collect on your\nsites, apps, and other properties and get consent where required by law or any\napplicable Google policies. See Google's ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/2998031",
            children: _jsx(_components.strong, {
              children: "About offline conversion\nimports"
            })
          }), " page for more\ndetails."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "eu-user-consent-policy-1",
        children: "EU user consent policy"
      }), "\n", _jsxs(_components.p, {
        children: ["If you are uploading data for users in the European Economic Area (", _jsx(_components.a, {
          href: "https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:European_Economic_Area_(EEA)",
          children: "EEA"
        }), "),\nyou need to ensure you are passing the required consent signals to ", _jsx(_components.a, {
          href: "https://www.google.com/about/company/user-consent-policy/?sjid=2196795394224792925-NA",
          children: "Google"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["For ", _jsx(_components.a, {
          href: "#syncing-click-conversions",
          children: "click conversions"
        }), ", ", _jsx(_components.a, {
          href: "#syncing-call-conversions",
          children: "call conversions"
        }), " and ", _jsx(_components.a, {
          href: "#syncing-offline-store-conversions",
          children: "offline store conversions"
        }), ", you can specify the Google consent status for advertising purposes, by mapping these fields in the sync configuration:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "Ad user data consent"
          }), " (for the ", _jsx(_components.code, {
            children: "ad_user_data"
          }), " property)"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "Ad personalization consent"
          }), " (for the ", _jsx(_components.code, {
            children: "ad_personalization"
          }), " property)"]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "permission_denied-from-data-manager-api",
        children: "PERMISSION_DENIED from Data Manager API"
      }), "\n", _jsxs(_components.p, {
        children: ["You may receive a ", _jsx(_components.code, {
          children: "403 - {\"error\":{\"code\":403,\"message\":\"The caller does not have permission\",\"status\":\"PERMISSION_DENIED\",\"domain\":\"datamanager.googleapis.com\"}}"
        }), " error when syncing to Google Ads."]
      }), "\n", _jsxs(_components.p, {
        children: ["This occurs when Hightouch creates the partner link during a sync run but the authenticating user doesn't have ", _jsx(_components.strong, {
          children: "Admin"
        }), " access on the Google Ads account. Google Data Manager checks access against the login account, which in manager-account setups is the manager (MCC) account. A user with a lower access level, such as Standard, can sign in successfully but can't create the partner link."]
      }), "\n", _jsx(_components.p, {
        children: "To verify the access level:"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Go to your Google Ads account."
        }), "\n", _jsxs(_components.li, {
          children: ["Open ", _jsx(_components.strong, {
            children: "Access and security"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["Open the ", _jsx(_components.strong, {
            children: "Users"
          }), " tab."]
        }), "\n", _jsxs(_components.li, {
          children: ["Turn off the ", _jsx(_components.strong, {
            children: "Show users in full hierarchy"
          }), " toggle."]
        }), "\n", _jsx(_components.li, {
          children: "Confirm the authenticating user is listed directly on the manager (MCC) account."
        }), "\n", _jsxs(_components.li, {
          children: ["Confirm the user's access level is ", _jsx(_components.strong, {
            children: "Admin"
          }), ". For more on access levels, see Google's ", _jsx(_components.a, {
            href: "https://support.google.com/google-ads/answer/9978556",
            children: "access levels"
          }), " documentation."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["If the user isn't an Admin, upgrade the access level and rerun the sync, or re-authorize the destination with a different user who has Admin access. If you can't grant Admin access, create the partner link manually and switch to the ", _jsx(_components.a, {
          href: "#existing-partner-link",
          children: _jsx(_components.strong, {
            children: "Existing Partner Link"
          })
        }), " authentication method instead."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
